import React from "react";

import { OrderProps } from "store/modules/Orders/types.store";
import {
  canChangeDriverInOrderDetails,
  canSelectDriverInOrderDetails,
  getOrderDeliveryPersonDisplayName,
  hasAssignedOrderDriver,
  shouldDisableOrderDriverSectionBorder,
} from "utils/coverageAreaDriverRules";

import DriverReadView from "./DriverReadView";
import DriverEditView from "./DriverEditView";
import { useOrderDriverSelection } from "./useOrderDriverSelection";
import * as Styled from "./styles";

const FINALIZED_TAB = "3";

interface OrderDriverSectionProps {
  data: OrderProps;
  currentTab?: string;
}

function OrderDriverSection({ data, currentTab }: OrderDriverSectionProps) {
  const isFinalizedTab = currentTab === FINALIZED_TAB;
  const placedOrigin = data?.placedOrigin;
  const deliveryPersonName = getOrderDeliveryPersonDisplayName({
    driver: data?.driver,
    coverageArea: data?.coverageArea,
  });
  const hasDriver = hasAssignedOrderDriver(data?.driver, data?.coverageArea);
  const canSelectDriver =
    canSelectDriverInOrderDetails(placedOrigin, isFinalizedTab) && !hasDriver;
  const canChangeDriver =
    canChangeDriverInOrderDetails(placedOrigin, isFinalizedTab) && hasDriver;

  const {
    isSelecting,
    loadingDrivers,
    driverOptions,
    driverInsightLoaded,
    selectedDriver,
    setSelectedDriver,
    openSelection,
    closeSelection,
    applySelection,
  } = useOrderDriverSelection({
    dealerId: data?.dealer?.id || "",
    orderId: data?.id || "",
    coverageAreaId: data?.coverageArea?.id,
  });

  return (
    <Styled.Wrapper
      $disableBorder={
        shouldDisableOrderDriverSectionBorder(placedOrigin) && !isSelecting
      }
    >
      {isSelecting ? (
        <DriverEditView
          loading={loadingDrivers}
          options={driverOptions}
          value={selectedDriver}
          showDriverInsight={driverInsightLoaded}
          onChange={setSelectedDriver}
          onCancel={closeSelection}
          onApply={applySelection}
        />
      ) : (
        <DriverReadView
          driverName={deliveryPersonName}
          canSelect={canSelectDriver}
          canChange={canChangeDriver}
          onSelect={openSelection}
        />
      )}
    </Styled.Wrapper>
  );
}

export default OrderDriverSection;
